var map = {
	"./tutorial-normal-competitiveness-4.jpg": "urdl",
	"./tutorial-tool-competitiveness-4.jpg": "pVaX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xYqJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/tutorial\-.*\-competitiveness\-4\.jpg$
// module id = xYqJ
// module chunks = 3